import React, {FC, HTMLAttributes} from "react"
import styled from "styled-components"


const StyledButton = styled.button`
    background-color: #3A5049;
    color: white;
    border-radius: 15px;
    padding: 20px 35px;
    cursor: pointer;
    margin-left: 10px
    font-size: 1em;
    text-transform: uppercase;
    position: relative;
    transition: all .3s;
    font-size: 1rem;
    border: none;
    &:hover {
      background: #ADC2A3;
      color: #fff;
    }
    & svg {
      display: inline;
      position: relative; 
      height: 15px; 
    }
    & svg path {
      fill: #fff;
    }
`;

const IconLeft = styled.span`
  margin-right: 10px;
`;

const IconRight = styled.span`
  margin-left: 10px;
`;

interface ButtonProps extends HTMLAttributes<HTMLButtonElement> {
  iconLeft?: string
  iconRight?: string
}


const Button: FC<ButtonProps> = ({ iconLeft, iconRight, ...props }) => (
  <StyledButton {...props}>
    {iconLeft && <IconLeft dangerouslySetInnerHTML={{ __html: iconLeft }}/>}
    {props.children}
    {iconRight && <IconRight dangerouslySetInnerHTML={{ __html: iconRight }}/>}
  </StyledButton>
);


export default Button